import jPositionList from '@/views/position/jPositionList';
import jPositionForm from '@/views/position/jPositionForm';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/administrator/position',
    name: 'Position',
    component: jPositionList,
    meta: {
      title: 'Position',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/position/update/:id',
    name: 'Update Position',
    component: jPositionForm,
    meta: {
      title: 'Update Position',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterPosition.js